import { Typography, Box, Grid, List, ListItem, Rating, Stack, Divider } from "@mui/material"

const Preview = ({fieldValues, selectedColor, fullHeight=false, page='preview', sections}) =>{
    let headerFontSize ='30px',subHeaderFontSize ='16px', headerPadding = 5, contentpadding = 3,subContentPadding = 1, titleFontSize = '20px', subTitleFontSize='18px', contentFontSize = '16px', ratingSize = '1.5rem';
    if(page === 'template'){
        headerFontSize = '16px'
        subHeaderFontSize = '10px'
        headerPadding = 2
        contentpadding = 1
        subContentPadding = 0.5
        titleFontSize = '12px'
        subTitleFontSize = '10px'
        contentFontSize = '10px'
        ratingSize = '1rem'
    }
    
    const getobjectiveContent = () => {
        return <Grid item xs={12} p={subContentPadding}>
            <Typography sx={{fontSize:titleFontSize, fontWeight: 600}}>Objective</Typography>         
            <Divider sx={{borderColor: selectedColor?.[1] || "#a98462" }}/>
            <Typography sx={{fontSize:contentFontSize}}>{fieldValues.objective}</Typography>
        </Grid>
    }
    const geteducationContent = () => {
        return <Grid item xs={12} p={subContentPadding}>
            <Typography sx={{fontSize:titleFontSize, fontWeight: 600}}>Education</Typography>    
            <Divider sx={{borderColor: selectedColor?.[1] || "#a98462" }}/>
            <Stack spacing={1} >
               {fieldValues.education.map((edu, index)=>{
                    return  <Grid key={index}><Typography sx={{fontSize:subTitleFontSize}}><strong>{edu.degree} {edu.field_of_study}</strong>, {edu.start_date[0]}-{edu.end_date[0]}</Typography>
                <Typography sx={{fontSize:contentFontSize}}>{edu.school_name}, {edu.school_location}</Typography></Grid>
                })}
           </Stack> 
        </Grid>
    }

    const getexperienceContent = () =>{
        return <Grid item xs={12} p={subContentPadding}>
            <Typography sx={{fontSize:titleFontSize, fontWeight: 600}}>Experience</Typography>
            <Divider sx={{borderColor: selectedColor?.[1] || "#a98462" }}/>
            <Stack spacing={1} >
                    {fieldValues.experience.map((exp, index)=>{
                        return <Grid key={index}><Typography sx={{fontSize:subTitleFontSize}}><strong>{exp.job_title} | {exp.employer}</strong>, {exp.start_date[0]} {exp.start_date[1]}-{exp.end_date[0]} {exp.end_date[1]}</Typography>
                    {exp.description ? <Typography sx={{fontSize:contentFontSize}} dangerouslySetInnerHTML={{__html: exp.description?._cache?.html ? exp.description?._cache?.html.toString('html') : exp.description.toString('html')}}></Typography> : ''}
                    </Grid>
                    })}
            </Stack> 
        </Grid>
    }

    const getskillsContent = () =>{
        return <Grid item xs={12} p={subContentPadding}>
        <Typography sx={{fontSize:titleFontSize, fontWeight: 600}}>Skills</Typography>
        <Divider sx={{borderColor: selectedColor?.[1] || "#a98462" }}/>
        <List>
            {fieldValues.skills.map((skill, index)=>{
                    return   <ListItem key={index} disablePadding sx={{display:'flex'}}>
                        <Grid container xs={12}>
                            <Grid item xs={4}>
                                <Typography sx={{fontSize:contentFontSize}}>{skill.skill}</Typography>
                            </Grid>
                            <Grid item xs={8}>
                            <Rating name="half-rating" sx={{fontSize: ratingSize, color: selectedColor?.[0] || '#000'}}  value={skill.rating ? parseFloat(skill.rating) : 1} precision={0.5}></Rating>
                            </Grid>
                        </Grid>
                </ListItem>
                })}                   
        </List>
    </Grid>
    }

    const getotherContent = () =>{
        return   fieldValues.other.map((other, index)=>{
            return <Grid item xs={12} key={index} p={subContentPadding}>
                {other.title ?  <><Typography sx={{fontSize:titleFontSize, fontWeight: 600}}>{other.title}</Typography>
                <Divider sx={{borderColor: selectedColor?.[1] || "#a98462" }}/></> :''}
                {other.content ? <Typography sx={{fontSize:contentFontSize}} dangerouslySetInnerHTML={{__html: other.content?._cache?.html ? other.content?._cache?.html.toString('html') : other.content.toString('html')}}></Typography> : ''}
            </Grid>
        })
    }

    return <Box sx={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", flexGrow:1,  width:"100%", height: fullHeight ? "100%" : 'auto' }} >
        <Grid item xs={12} p={headerPadding} sx={{background: selectedColor?.[0] || "#bc936d"}}>
            <Typography sx={{fontSize:headerFontSize, fontWeight:600, color: selectedColor?.[2] || '#000'}}>{fieldValues.f_name || 'John'} {fieldValues.l_name}</Typography>
            <Typography sx={{fontSize:subHeaderFontSize, color: selectedColor?.[2] || '#000'}}>{fieldValues.city || 'Chennai'} | {fieldValues.state || 'Tamilnadu'}</Typography>
            <Typography sx={{fontSize:subHeaderFontSize, color: selectedColor?.[2] || '#000'}}>{fieldValues.email || 'xxx@gmail.com'}</Typography>
            <Typography sx={{fontSize:subHeaderFontSize, color: selectedColor?.[2] || '#000'}}>{fieldValues.phone || '9876543210'}</Typography>
        </Grid>
        <Grid item xs={12} p={contentpadding}>
            {sections?.map((section)=>{
                    if(section === 'Objective'){
                        return fieldValues.objective ? getobjectiveContent() : ''
                    }else if(section === 'Education'){
                        return fieldValues.education.length ? geteducationContent() : ''
                    }else if(section === 'Experience'){
                        return fieldValues.experience.length ? getexperienceContent() : ''
                    }else if(section === 'Skills'){
                        return fieldValues.skills.length ? getskillsContent() : ''
                    }else if(section === 'Other'){
                        return fieldValues.other.length && fieldValues.other[0].title ? getotherContent() : ''
                    }
                    return ''
                })
            }
        </Grid>
  </Box>
}

export default Preview